<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          color: '#0BA137',
          icon: 'mdi-domain',
          title: 'Business setup',
          text: 'We do undertake company registration (Incorporation), the most essential service for entrepreneur who wants to start up companies in Sri Lanka based . KCS will undertake company formations at a very reasonable price.',
        },
        {
          color: '#0BA137',
          icon: 'mdi-currency-usd-circle-outline',
          title: 'Payroll Management',
          text: 'KCS provides a range of Payroll services to diverse sectors, which operate based on multiple policies and regulatory frameworks . The right payroll solution will enable businesses to save time and money, as well as avoid man-made errors. So, choose the best one',
        },
        {
          color: '#0BA137',
          icon: 'mdi-book',
          title: 'Online Bookkeeping',
          text: 'Say goodbye to complicated and costly bookkeeping and say hello to secure, accessible and efficient cloud (Online) bookkeeping services. Save both time and money, and focus on what you do best develop your business.',
        },
        {
          color: '#0BA137',
          icon: 'mdi-puzzle-outline',
          title: 'Legal Services',
          text: 'Protect your Trademarks, Intellectual property or get your contracts in order, we’ve got someone who specializes in the problems you have. Our experts can provide expert commercial advice on many legal matters that your business may be facing',
        },
      ],
    }),
  }
</script>
